import React from 'react';
import loadable from '@loadable/component';
import retry from '~/utils/retry';
import PopmenuLoading from '~/admin/shared/PopmenuLoading';

const RestaurantInfoStep = loadable(() => retry(() => import('./RestaurantInfoStep')), {
  fallback: <PopmenuLoading />,
});

export default RestaurantInfoStep;
